import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onClose: () => void;
    onRemoveJob: () => void;
};

const RemoveJobFromManifestModal = ({ open, onClose, onRemoveJob }: Props) => {
    return (
        <ConfirmationModal
            open={open}
            width={580}
            type="default"
            title="Remove from manifest?"
            confirmButtonText="Remove Job"
            onConfirm={onRemoveJob}
            onCancel={onClose}
            content={
                <Typography.Text>
                    The job will be removed from this manifest but remain available in your draft jobs for future use.
                </Typography.Text>
            }
        />
    );
};

export default RemoveJobFromManifestModal;
